<p-dialog header="Add to Organization"
          [(visible)]="showModal"
          (onHide)="closeModal()"
          [modal]="true"
          [resizable]="false"
          [contentStyle]="{ overflow: 'visible'}"
          [style]="{ width: '45rem' }">
    <p>Select an existing organization to add this site to. The site will need to be confirmed by an Organization Admin before data populates from the site.</p>
    <label for="enterpriseSelection" class="fw-normal">Organization <span class="text-danger">*</span></label>
    <ng-select id="enterpriseSelection"
               data-identifier="add-to-organization-enterprise-selection"
               [(ngModel)]="selectedEnterprise"
               [items]="(enterprises | async) ?? []"
               (open)="enterpriseSearchSubject.next('')"
               (clear)="selectedEnterprise = undefined"
               [typeahead]="enterpriseSearchSubject"
               placeholder="Search">
        <ng-template ng-label-tmp let-item="item">
            <div class="row">
                <div class="col-sm-auto pe-0">{{ item.name }}</div>
                <div class="col-sm-auto ps-1 enterprise-alias-label">{{ item.alias }}{{ item.orgAdminDomain }}</div>
            </div>
        </ng-template>
        <ng-template ng-header-tmp>
            <div class="row">
                <div class="col-3">Organization</div>
                <div class="col-6">Organization Admin URL</div>
                <div class="col-1">Sites</div>
            </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
            <div data-identifier="add-to-organization-enterprise-option" class="row">
                <div class="col-3">{{ item.name }}</div>
                <div class="col-6">{{ item.alias }}{{ item.orgAdminDomain }}</div>
                <div class="col-1">{{ item.activeOrganizationsCount }}</div>
            </div>
        </ng-template>
    </ng-select>
    <hr class="mt-5">
    <div class="d-flex justify-content-end">
        <button data-identifier="add-to-organization-cancel" class="btn btn-sm btn-default me-2"
                (click)="closeModal()">Cancel
        </button>
        <button data-identifier="add-to-organization-add" class="btn btn-sm btn-primary"
                [disabled]="!selectedEnterprise" (click)="addToOrganization()">Add
        </button>
    </div>
</p-dialog>
